module.exports = __webpack_public_path__ + "static/media/19.8e531a4f.jpg";